import { BellOutlined, CreditCardOutlined, FileTextOutlined, LockOutlined, ShoppingOutlined, UserOutlined } from "@ant-design/icons";
import { Card, Col, Layout, Menu, Row } from "antd";
import NotificationSettings from "containers/NotificationSettings";
import UserProfileDetails from "containers/UserProfileDetails";
import { useState } from "react";

const { Content, Sider } = Layout;

const UserProfile = () => {
    const [selectedMenu, setSelectedMenu] = useState(["PROFILE"]);

    return (
        <Layout className="layout-user-profile-main">
            <Layout>
                <Sider width={280} className="sider-user-profile-menu">
                    <Row style={{ width: "100%", height: "100%" }}>
                        <Col span={24} style={{ display: "flex", flexDirection: "column", flexWrap: "nowrap" }}>
                            <Row style={{ width: "100%" }}>
                                <Col span={24}>
                                    <Card size="small" title="SETTINGS" variant="outlined" styles={{ header: { border: 0 }, body: { paddingLeft: 0, paddingRight: 0 } }}>
                                        <Menu
                                            mode="inline"
                                            style={{ width: "100%", border: 0 }}
                                            selectedKeys={selectedMenu}
                                            items={[
                                                {
                                                    label: (
                                                        <>
                                                            <UserOutlined /> Profile
                                                        </>
                                                    ),
                                                    key: "PROFILE",
                                                    onClick: () => setSelectedMenu(["PROFILE"]),
                                                },
                                                {
                                                    label: (
                                                        <>
                                                            <BellOutlined /> Notifications
                                                        </>
                                                    ),
                                                    key: "NOTIFICATIONS",
                                                    onClick: () => setSelectedMenu(["NOTIFICATIONS"]),
                                                },
                                                {
                                                    label: (
                                                        <>
                                                            <LockOutlined /> Security
                                                        </>
                                                    ),
                                                    key: "SECURITY",
                                                    disabled: true,
                                                },
                                            ]}
                                        />
                                    </Card>
                                </Col>
                            </Row>
                            <Row style={{ width: "100%", marginTop: "2rem" }}>
                                <Col span={24}>
                                    <Card size="small" title="BILLING" variant="outlined" styles={{ header: { border: 0 }, body: { paddingLeft: 0, paddingRight: 0 } }}>
                                        <Menu
                                            mode="inline"
                                            style={{ width: "100%", border: 0 }}
                                            items={[
                                                {
                                                    label: (
                                                        <>
                                                            <ShoppingOutlined /> Plans
                                                        </>
                                                    ),
                                                    key: "PLANS",
                                                    disabled: true,
                                                },
                                                {
                                                    label: (
                                                        <>
                                                            <CreditCardOutlined /> Subscription
                                                        </>
                                                    ),
                                                    key: "SUBSCRIPTION",
                                                    disabled: true,
                                                },
                                                {
                                                    label: (
                                                        <>
                                                            <FileTextOutlined /> Invoice
                                                        </>
                                                    ),
                                                    key: "INVOICE",
                                                    disabled: true,
                                                },
                                            ]}
                                        />
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Sider>
                <Layout style={{ paddingLeft: "2rem" }}>
                    <Content style={{ height: "100%" }}>
                        {selectedMenu[0] === "PROFILE" && (
                            <div style={{ height: "100%" }}>
                                <UserProfileDetails />
                            </div>
                        )}
                        {selectedMenu[0] === "NOTIFICATIONS" && (
                            <div style={{ height: "100%" }}>
                                <NotificationSettings />
                            </div>
                        )}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default UserProfile;
